class ProductTabs extends HTMLElement {
    connectedCallback() {
        this.tabButtons = this.querySelectorAll('.tab-button');
        this.tabContents = this.querySelectorAll('.tab-content');
        this.underline = this.querySelector('[data-underline]');
        this.tabRow = this.querySelector('.tabs-row');

        if (!this.tabButtons.length) return;

        this.tabButtons[0].classList.add('active');

        this.tabButtons.forEach((button) => {
            button.addEventListener('click', () => {
                const targetTab = button.dataset.tab;
                this.switchTab(targetTab, button);
            });
        });

        this.resizeObserver = new ResizeObserver(() => {
            const activeBtn = this.querySelector('.tab-button.active');
            if (activeBtn) this.updateUnderline(activeBtn);
        });

        this.resizeObserver.observe(this);
    }

    disconnectedCallback() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    }

    switchTab(targetTab, clickedButton) {
        this.tabButtons.forEach((btn) => btn.classList.remove('active'));
        clickedButton.classList.add('active');

        this.tabContents.forEach((content) => {
            content.classList.toggle(
                'active',
                content.dataset.content === targetTab
            );
        });

        this.updateUnderline(clickedButton);
    }

    updateUnderline(button) {
        if (!this.underline || !this.tabRow) return;

        const buttonRect = button.getBoundingClientRect();
        const containerRect = this.tabRow.getBoundingClientRect();

        this.underline.style.left = `${buttonRect.left - containerRect.left}px`;
        this.underline.style.width = `${buttonRect.width}px`;
    }
}

customElements.define('product-tabs', ProductTabs);